import { InjectionToken } from '@angular/core';

export const DASHBOARD_PREFERENCES_STORAGE = new InjectionToken<Storage>('DashboardPreferencesStorage');
